import React from 'react';
import { Link } from 'react-router-dom';
import { BtnPrimary } from '../components/ui';

export default function NotFoundPage() {
  return (
    <section style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: 40, paddingTop: 100 }}>
      <div>
        <div style={{ fontSize: '6rem', marginBottom: 20 }}>🌙</div>
        <h2 className="serif" style={{ fontSize: '3rem', marginBottom: 12 }}>Page Not Found</h2>
        <p style={{ color: 'var(--brown)', marginBottom: 24 }}>The page you're looking for doesn't exist.</p>
        <Link to="/"><BtnPrimary>Return Home</BtnPrimary></Link>
      </div>
    </section>
  );
}
